
        import { h, render, defineComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from 'vue';
        const __svgComponent = defineComponent({
          

 render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M16.25 3.27344H14.375V2.64844C14.375 2.48268 14.3092 2.32371 14.1919 2.2065C14.0747 2.08929 13.9158 2.02344 13.75 2.02344C13.5842 2.02344 13.4253 2.08929 13.3081 2.2065C13.1908 2.32371 13.125 2.48268 13.125 2.64844V3.27344H6.875V2.64844C6.875 2.48268 6.80915 2.32371 6.69194 2.2065C6.57473 2.08929 6.41576 2.02344 6.25 2.02344C6.08424 2.02344 5.92527 2.08929 5.80806 2.2065C5.69085 2.32371 5.625 2.48268 5.625 2.64844V3.27344H3.75C3.41848 3.27344 3.10054 3.40513 2.86612 3.63955C2.6317 3.87397 2.5 4.19192 2.5 4.52344V17.0234C2.5 17.355 2.6317 17.6729 2.86612 17.9073C3.10054 18.1417 3.41848 18.2734 3.75 18.2734H16.25C16.5815 18.2734 16.8995 18.1417 17.1339 17.9073C17.3683 17.6729 17.5 17.355 17.5 17.0234V4.52344C17.5 4.19192 17.3683 3.87397 17.1339 3.63955C16.8995 3.40513 16.5815 3.27344 16.25 3.27344ZM5.625 4.52344V5.14844C5.625 5.3142 5.69085 5.47317 5.80806 5.59038C5.92527 5.70759 6.08424 5.77344 6.25 5.77344C6.41576 5.77344 6.57473 5.70759 6.69194 5.59038C6.80915 5.47317 6.875 5.3142 6.875 5.14844V4.52344H13.125V5.14844C13.125 5.3142 13.1908 5.47317 13.3081 5.59038C13.4253 5.70759 13.5842 5.77344 13.75 5.77344C13.9158 5.77344 14.0747 5.70759 14.1919 5.59038C14.3092 5.47317 14.375 5.3142 14.375 5.14844V4.52344H16.25V7.02344H3.75V4.52344H5.625ZM16.25 17.0234H3.75V8.27344H16.25V17.0234Z",
      fill: "#47586E"
    })
  ]))
},
          mounted() {
            // Mount logic
          },
          unmounted() {
            // Unmount logic
          }
        });

        export default __svgComponent;
        